import React, { ReactElement } from 'react';
import { PopupForm } from 'features/nekst-widgets';
import CreateStandardPlanTaskForm from './Standard/CreateStandardPlanTaskForm';
import { CreateEmailTaskForm } from './Email/CreateEmailTaskForm';
import { CreateSmsTaskForm } from './Sms/CreateSmsTaskForm';
import { CreateEventTaskForm } from './Event/CreateEventTaskForm';
import { usePopupManager } from 'ui-builder';
import { PlanTask } from 'nekst-api';

export default function usePlanTaskForms() {
  const popupManager = usePopupManager();

  const openForm = (form: ReactElement) => {
    popupManager.openPopup(
      <PopupForm>
        {form}
      </PopupForm>,
    );
  };

  const openCreateStandardTaskForm = (
    planId: number,
    parentTask?: PlanTask,
    isProceeding = false
  ) => {
    openForm(<CreateStandardPlanTaskForm
      planId={planId}
      parentTask={parentTask}
      isProceeding={isProceeding}
    />);
  };

  const openCreateEmailTaskForm = (
    planId: number,
    parentTask?: PlanTask,
    isProceeding = false
  ) => {
    openForm(
      <CreateEmailTaskForm
        planId={planId}
        parentTask={parentTask}
        isProceeding={isProceeding}
      />,
    );
  };

  const openCreateSmsTaskForm = (
    planId: number,
    parentTask?: PlanTask,
    isProceeding = false
  ) => {
    openForm(<CreateSmsTaskForm planId={planId} parentTask={parentTask} isProceeding={isProceeding} />);
  };

  const openCreateEventTaskForm = (
    planId: number,
    parentTask?: PlanTask,
    isProceeding = false
  ) => {
    openForm(
      <CreateEventTaskForm
        planId={planId}
        parentTask={parentTask}
        isProceeding={isProceeding}
      />,
    );
  };

  return {
    openCreateStandardTaskForm,
    openCreateEmailTaskForm,
    openCreateSmsTaskForm,
    openCreateEventTaskForm,
  };
}
